import React, { useState, useEffect } from "react";
import { selectGenreOrCategory } from "../../features/currentGenreOrCategory";
import { Link, useParams } from "react-router-dom";
import { useGetListQuery, useGetMovieQuery, useGetRecommentationQuery } from "../../services/TMDB";
import useStyle from "./Styles";
import genreIcons from "../../assets/genres";
import {
  Modal,
  Typography,
  Button,
  ButtonGroup,
  Grid,
  Box,
  CircularProgress,
  Rating,
  List,
} from "@mui/material";
import {
  Movie as MovieIcon,
  Theaters,
  Language,
  PlusOne,
  Favorite,
  FavoriteBorderOutlined,
  Remove,
  ArrowBack,
  PlusOneOutlined,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import MovieList from '../MovieList/MovieList';
import axios from "axios";
import { userSelector } from "../../features/auth";
const MovieInformation = () => {
  const dispatch = useDispatch();
  const {user} = useSelector(userSelector);
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const classes = useStyle();
  const [isMovieFavorited, setIsMovieFavorited] = useState(false);
  const [isMovieWatchlisted, setIsMovieWatchlisted] = useState(false);
  const { data, isFetching, error } = useGetMovieQuery(id);
  
  // Get Recommendation Movies through Redux
  const { data: recommendationMovie, isFetching: recommendationFetching, error: recommendationError } = useGetRecommentationQuery({ list: '/recommendations', movie_id: id })
  
  // Get favorite Movies through redux if it exists
  const { data: favoriteMovies } = useGetListQuery({ listName: 'favorite/movies', accountId: user.id, sessionId: localStorage.getItem("session_id"), page: 1 });
  
  // Get Watchlist Movies through redux if it exists
  const { data: watchlistMovies } = useGetListQuery({ listName: 'watchlist/movies', accountId: user.id, sessionId: localStorage.getItem("session_id"), page: 1 });


  console.log('rec', recommendationMovie);

  useEffect(() => {
    favoriteMovies && data &&
      setIsMovieFavorited(!!favoriteMovies.results.find((movie) => movie.id === data.id));

    watchlistMovies && data &&
    setIsMovieWatchlisted(!!watchlistMovies.results.find((movie) => movie.id === data.id))
  }, [favoriteMovies, watchlistMovies, data])

  if (isFetching) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress size="8rem" />
      </Box>
    );
  }
  if (error) {
    return (
      <Box display="flex" justifyContent="center">
        <Link to="/">Something has gone wrong Go Back</Link>
      </Box>
    );
  }
  const addToFavorites = async () => {
    try {
      await axios.post(`https://api.themoviedb.org/3/account/${user.id}/favorite?api_key=8c6692ba8128208c233dd86f597e6434&session_id=${localStorage.getItem('session_id')}`, {
        
        media_type: 'movie',
        media_id: id,
        favorite:!isMovieFavorited,
      })
    } catch (error) {
      console.log('error', error)   
    }

    setIsMovieFavorited((prev) => !prev)
  }

  const addToWatchList = async () => {
    try {
      await axios.post(`https://api.themoviedb.org/3/account/${user.id}/watchlist?api_key=8c6692ba8128208c233dd86f597e6434&session_id=${localStorage.getItem('session_id')}`, {
        
        media_type: 'movie',
        media_id: id,
        watchlist:!isMovieWatchlisted,
      })
    } catch (error) {
      console.log('error', error)   
    }

    setIsMovieWatchlisted((prev) => !prev)
  }

  return (
    <div>
      <Grid container className={classes.ContinerSpaceAround}>
        <Grid item sm={12} lg={4} style={{display:"flex", alignItems:"center", justifyContent:"center", marginBottom:"30px", width:"100%"}}>
          <img
            className={classes.poster}
            src={`https://image.tmdb.org/t/p/w500/${data.poster_path}`}
            alt=""
          />
        </Grid>
        <Grid item container direction="column" lg="7">
          <Typography variant="h3" align="center" gutterBottom>
            {data.title} ({data.release_date.split("-")[0]}){" "}
          </Typography>
          <Typography variant="h5" align="center" gutterBottom>
            {data.tagline}
          </Typography>

          <Grid item className={classes.ContinerSpaceAround}>
            <Box display="flex" align="center">
              <Rating readOnly value={data.vote_average / 2} />
              <Typography
                variant="subtitle1"
                gutterBottom
                style={{ marginLeft: "10px" }}
              >
                {data.vote_average} / 10{" "}
              </Typography>
            </Box>

            <Typography variant="h6" align="center" gutterBottom>
              {data.runtime} min{" "}
              {data.spoken_languages.length > 0
                ? `/${data.spoken_languages[0].name}`
                : ""}
            </Typography>
          </Grid>

          <Grid item className={classes.genresContainer}>
            {data.genres.map((genre, i) => (
              <Link
                key={genre.name}
                className={classes.links}
                to="/"
                onClick={() => {
                  dispatch(selectGenreOrCategory(genre.id));
                }}
              >
                <img
                  src={genreIcons[genre.name.toLowerCase()]}
                  alt="image"
                  className={classes.genreImage}
                  height={30}
                />

                <Typography style={{textUnderline:'none'}} variant="subtitle1" color="textPrimary">
                  {genre.name}
                </Typography>
              </Link>
            ))}
          </Grid>
          <Typography variant="h5" gutterBottom style={{marginTop:"10px"}}  color="textPrimary">
            Overview
          </Typography>

          <Typography style={{marginBottom:'2rem'}}   color="textPrimary">
            {data.overview}
          </Typography>

          <Typography variant="h5" gutterBottom >
            Top Cast
          </Typography>

          <Grid item container spacing={2}> 
            {data && data.credits.cast.map((character, i) => (
              character.profile_path && 
              <Grid  key={i} item xs={4} md={2} component={Link} to={`/actor/${character.id}`} style={{ textDecoration: 'none' }}>
                  <img className={classes.castImage} src={`https://image.tmdb.org/t/p/w500/${character.profile_path}`} alt={character.name} />
                  <Typography color='textPrimary'>
                    {character.name}
                    
                  </Typography>
                  {console.log(character.order)}
                  <Typography color='textSecondary'>
												{character.character.split('/')[0]}
											</Typography>

              </Grid>
            )).slice(0, 6)}
          </Grid>
          <Grid item container style={{ marginTop: "2rem" }}>
            <div className={classes.buttonContainer}>
              <Grid item xs={12} sm={6}>
                <ButtonGroup size="small" variant="outlined">
                  <Button target="_blank" rel="noopener noreferrer" href={data.homepage} endIcon={<Language />}>Website</Button>

                  <Button target="_blank" rel="noopener noreferrer" href={`https://www.imdb.com/title/${data.imdb_id}`} endIcon={<MovieIcon />}>IMDB</Button>

                  
                  <Button  onClick={() => setOpen(true)}  href='#'  endIcon={<Theaters />}>Trailer</Button>

                </ButtonGroup>

              </Grid>

              <Grid item xs={12} sm={6}>
                <ButtonGroup size="small" variant="outlined">
                  <Button onClick={addToFavorites} endIcon={isMovieFavorited ? <FavoriteBorderOutlined /> : <Favorite />}>
                  {isMovieFavorited ? 'Unfavorite' : 'Favorite'}</Button>

                    <Button onClick={addToWatchList} endIcon={isMovieWatchlisted ? <Remove /> : <PlusOneOutlined />}>WatchList</Button>

                  
                  <Button onClick={() => { }} sx={{ borderColor: 'Primary.main' }} href='#' endIcon={<ArrowBack />}>
                    <Typography style={{textDecoration:'none'}} component={Link} to='/' color="inherit" variant="subtitle2">Back</Typography>
                  </Button>

                </ButtonGroup>

              </Grid>
            </div>
          </Grid>
        </Grid>
      </Grid>

      <Box marginTop='5rem' width='100%'>
          <Typography variant="h3" gutterBottom align="center">
            You might also like this
        </Typography>
        
        {recommendationMovie ? 
          <MovieList movies={recommendationMovie} numberOfRows={'8'} /> 
          :
          <Box>
            Sorry Nothing Was Found
          </Box>    
      }
      </Box>
      <Modal closeAfterTransition className={classes.modal} open={open} onClose={() => setOpen(false)}>
        {data.videos.results.length > 0 && (
          <iframe autoPlay className={classes.video} frameBorder="0" title="Trailer" src={`https://www.youtube.com/embed/${data.videos.results[0].key}`} allow="autoplay " />

        )}
      </Modal>
    </div>
  );
};

export default MovieInformation;
